export default __webpack_public_path__ + "static/section2_background-4ee535bf6fc20300fea7febd43d99adb.png";